import { render, staticRenderFns } from "./consent-education.vue?vue&type=template&id=4869fee7&"
import script from "./consent-education.vue?vue&type=script&lang=js&"
export * from "./consent-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "consent-education.vue"
export default component.exports